export const fontWeights = {
  regular: 400,
  semibold: 600,
  bold: 700,
  // Rótulos, chips, contadores e abas ativas: no DS o peso faz a hierarquia.
  heavy: 800,
} as const;

export const fontSizes = {
  xs: 11,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 20,
} as const;

export const fontFamilies = {
  body: "Mulish, sans-serif",
  heading: "Outfit, sans-serif",
  mono: "Monaco, Courier, monospace",
} as const;
